/**
 * Podpowiedzi barw dla `ColorInput` — wspólne dla wszystkich pól koloru w apce
 * (kategorie kosztowe, tagi), żeby kolory nadawane ręcznie trzymały się jednej
 * palety. Pole hex zostaje: operator i tak może wybrać dowolny kolor.
 */
export const colorPresets = [
  '#EF4444',
  '#F97316',
  '#FF8800',
  '#EAB308',
  '#22C55E',
  '#14B8A6',
  '#3B82F6',
  '#6366F1',
  '#A855F7',
  '#EC4899',
  '#78716C',
  '#9E9E9E',
];
